import { render } from "./AppMain.vue?vue&type=template&id=07658394"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\me\\mayun\\lxk_admin_manage\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_eee4889a858be1e5640b6fb3f8529091\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__